import { useTranslation } from 'react-i18next';

import styled from '@emotion/styled';

interface ConfirmModalProps {
  title: string;
  contents: string | React.ReactElement;
  transComponents?: React.ReactElement;
  onClickButton?: () => void;
  closeAllModals: () => void;
}

export default function ConfirmBody({
  title,
  contents,
  transComponents,
  onClickButton,
  closeAllModals,
}: ConfirmModalProps) {
  const { t } = useTranslation();

  return (
    <SModalBody>
      <div className="head-section">
        <div className="title">{transComponents ? transComponents : title}</div>
        <div className="content">{contents}</div>
      </div>
      <SCheckButton
        onClick={() => {
          closeAllModals();
          onClickButton && onClickButton();
        }}
      >
        {t('setting.edit_ok_button')}
      </SCheckButton>
    </SModalBody>
  );
}

const SModalBody = styled.div`
  width: 320px;
  padding: 34px 30px 30px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.color.popup.background};

  .head-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 260px;
  }

  .title {
    color: ${({ theme }) => theme.color.text.TXT_3};
    ${({ theme }) => theme.font.body1_sb};
  }

  .content {
    color: ${({ theme }) => theme.color.text.TXT_2};
    ${({ theme }) => theme.font.body2_r};
  }

  @media ${({ theme }) => theme.device.small} {
    width: 300px;
    max-width: 100%;

    .title {
      ${({ theme }) => theme.font.head6_sb};
    }

    .head-section {
      width: 100%;
    }
  }
`;

const SCheckButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 260px;
  height: 46px;
  border-radius: 8px;
  background: ${({ theme }) => theme.color.static.primary};
  color: ${({ theme }) => theme.color.label.onAccent};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  @media ${({ theme }) => theme.device.small} {
    width: 100%;
  }
`;
